import {
  ApplicationConfig,
  importProvidersFrom,
  LOCALE_ID,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideAnimations } from '@angular/platform-browser/animations';
import localeEsAr from '@angular/common/locales/es-AR';
import { provideRouter, withRouterConfig } from '@angular/router';
import { appRoutes } from './app.routes';
import { API_CONFIG, APP_VERSION, CHANNEL, CHANNEL_QUOTE_ENUM, RECAPTCHA_SITE_KEY } from '@webapp/core/config';
import { provideWebPlatform } from '@webapp/platform';
import { provideRiskPlugins } from '@webapp/risk-core';
import { ALL_RISK_PLUGINS, DEFAULT_PLUGIN } from '@webapp/risks/plugins/all-risk-plugins';
import { provideWebRiskUi } from '@webapp/risks/web';
import { environment } from '../environments/environment';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { channelInterceptor } from '@webapp/core/helpers/channel.nterceptor';
import { HttpErrorInterceptor } from '@webapp/core/helpers/error.interceptor';
import { JwtModule } from '@auth0/angular-jwt';
import { registerLocaleData } from '@angular/common';
import { provideNgxMask } from 'ngx-mask';

registerLocaleData(localeEsAr, 'es-AR');

export const appConfig: ApplicationConfig = {
  providers: [
    provideNgxMask(),
    provideHttpClient(
      withInterceptors([channelInterceptor, HttpErrorInterceptor])
    ),
    provideAnimations(),
    provideWebPlatform(),
    provideRiskPlugins(ALL_RISK_PLUGINS, DEFAULT_PLUGIN),
    provideWebRiskUi(),
    importProvidersFrom([
      JwtModule.forRoot({
        config: {
          // The access token now lives only in AuthService's in-memory signal
          // (cookies carry the session across reloads). JwtModule is kept solely
          // for JwtHelperService DI — every decode/expiry call now passes an
          // explicit token, so this getter is intentionally never read.
          tokenGetter: () => null,
        },
      }),
    ]),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      appRoutes,
      withRouterConfig({
        urlUpdateStrategy: 'deferred',
        
      })
    ),
    { provide: LOCALE_ID, useValue: 'es-AR' },
    { provide: API_CONFIG, useValue: environment.apiUrl },
    { provide: CHANNEL, useValue: CHANNEL_QUOTE_ENUM.DIRECT },
    { provide: APP_VERSION, useValue: environment.version },
    { provide: RECAPTCHA_SITE_KEY, useValue: environment.recaptchaSiteKey },
  ],
};
